import React from "react";
import HcsCaptionControl from "./hcs-captioncontrol";
import HcsInfoButton from "./hcs-info-button";

/**
 * @class
 * @classdesc Trigger button as thumbnails or list.
 *
 * @param {object} props - Control properties. See {@link HcsControl} for common properties.
 * @param {string} type - Changes the mode or styling. Possible values are:
 * thumbs: Style with large thumbs buttons and description below the image
 * list: List style with left hand icon and description next to it.
 */
export default class HcsImageButtonGroup extends HcsCaptionControl {
    constructor(props) {
        super(props);

        this.buttonClicked = this.buttonClicked.bind(this);

        this.ref = React.createRef();
    }

    buttonClicked(item) {
        const { data, hcs } = this.props;

        let ccaoData = null;

        if(item.data && item.data.CCAO_DATA) {
            try {
                ccaoData = JSON.parse(item.data.CCAO_DATA);
            } catch(e) {
                console.error("Error parsing CCAO_DATA object from ECS: " + e.message + ": " + item.data.CCAO_DATA);
            }
        }

        if(ccaoData) {
            switch(this.props.type) {
                case "thumbs":
                    if(ccaoData.triggerEvent) {
                        hcs.api.configTrigger({
                            groupId: data.data.AGROUP,
                            itemId: data.ident,
                            data: ccaoData.triggerEvent
                        });
                    }
                    break;

                case "list":
                    if(ccaoData.ruleEngine) {
                        hcs.api.configTrigger({
                            groupId: data.data.AGROUP,
                            itemId: data.ident,
                            data: ccaoData.ruleEngine.exec.set[0].value,
                            dataOld: ccaoData.triggerEvent                  //?-- Unklar warum nicht auch das hier als "data"
                        });
                    }
                    break;
            }
        }
    }

    childClass() {
        return ["hcs-imagebuttongroup", "hcs-type-" + this.props.type];
    }

    /**
     * Resolve different types of image URL.
     * @param {string} dataUrl - Image URL, CSS class name of font code.
     * @returns {object} Resolved control depending on given image URL.
     */
    resolveIcon(dataUrl) {
        const { hcs } = this.props;

        if(dataUrl.startsWith("icon-code:")) {
            let iconCode = dataUrl.substring("icon-code:".length);

            return <svg icon-id={iconCode} version="2.0">
                <use href={"#" + iconCode}></use>
            </svg>;
        } else if(dataUrl.startsWith("font-code:")) {
            let uid = hcs.api.createUniqueId("hcs-listselect-item");
            let fontCode = dataUrl.substring("font-code:".length);

            return <React.Fragment>
                <style dangerouslySetInnerHTML={{
                    __html: `#${uid}:before { content: '${fontCode}'; }`
                }} />
                <div id={uid} className="hcs-icon-font"></div>
            </React.Fragment>;
        }

        if(dataUrl.startsWith("css-class:")) {
            let cssClass = dataUrl.substring("css-class:".length);
            return <div className={"hcs-class-icon " + cssClass}></div>
        }

        return <img src={hcs.api.getUrl("ConfigImage/icons", dataUrl || "null.png")} />;
    }

    render() {
        const { data } = this.props;

        return super.render(
            <ul ref={this.ref}>
                {
                    data.values.filter((item) => { return item.info.visible; }).map(function(item, index) {
                        return (
                            <li key={`hcs-imageselect-${data.ident}-${index}`} ecs-key={item.ident}>
                                <a className="hcs-icon-link" title={item.info.trans} onClick={this.buttonClicked.bind(this, item)}>
                                    {this.resolveIcon(item.data.IMAGE)}
                                    <span>{item.info.trans}</span>
                                </a>
                                {item.data.TOOLTIP ?
                                    <HcsInfoButton contentHtml={item.data.TOOLTIP} /> : null
                                }
                            </li>
                        );
                    }, this)
                }
            </ul>
        );
    }
}
